import React from 'react'
import { useState } from 'react'

const VehiclesItem = ({ oneVehicle }) => {
  const [active, setActive] = useState(false);
  const handleCollapse = () => {
    setActive(!active);
  };

  console.log(oneVehicle.documentNumber)

  return (
    <div className="div-vehicles" onClick={handleCollapse}>
      <span key={oneVehicle.id}>
        <i className="bi bi-truck">
          {" "}
          <strong>
            {oneVehicle.letters}
            {oneVehicle.numbers}
          </strong>
        </i>
      </span>
      <br></br>
      {active && (
        <div>
          <span>
            <i className="bi bi-calendar">
              {`Documento propietario: `}
              <strong>{oneVehicle.documentNumber}</strong>
            </i>
          </span>
        </div>
      )}
    </div>
  );
};

export default VehiclesItem